import { Service } from './Service';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class DashboardService extends Service {
  static get endpoint() {
    return 'dashboard';
  }

  static async getRequestVacationConflicts() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.endpoint}/vacation-conflicts`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getRequestHolidayConflicts() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.endpoint}/holiday-conflicts`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
